/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action } from 'mobx';
import mergeDeep from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import themes from '../themes';

class UiStore {
    @observable isMenuCollapsed = true;
    @observable themeName = 'light';
    @observable theme = themes.getTheme('light');
    @observable navigationIsLocked = false;

    @action
    reset = () => {
        this.themeName = 'light';
        this.theme = themes.getTheme('light');
    };

    @action.bound
    collapseMenu(isCollapsed) {
        this.isMenuCollapsed = !!isCollapsed;
    }

    @action.bound
    toggleSidebar() {
        this.isMenuCollapsed = !this.isMenuCollapsed;
    }

    @action.bound
    setTheme(theme) {
        this.themeName = theme;
        this.theme = themes.getTheme('theme');
    }

    @action.bound
    lockNavigation() {
        if (this.navigationIsLocked === true) return;
        this.navigationIsLocked = true;
    }

    @action.bound
    unlockNavigation() {
        if (this.navigationIsLocked === false) return;
        this.navigationIsLocked = false;
    }

    mergeThemes = (a, b) => mergeDeep(cloneDeep(a), b);
}

export default new UiStore();
